<script setup lang="ts">
import { SecondaryButton } from '@hfc/ui-core';

const props = withDefaults(defineProps<{
  title: string;
  subtitle?: string;
  phone?: string;
  buttonText?: string;
  buttonLink?: string | (() => void);
  showPhone?: boolean;
}>(), {
  showPhone: true,
});

const handleClick = (): void => {
  if (typeof props.buttonLink === 'function') {
    props.buttonLink();
  } else if (typeof props.buttonLink === 'string') {
    window.location.href = props.buttonLink;
  }
};
</script>
<template>
  <div class="flex flex-row rounded-xl shadow-md border border-slate-100 bg-white min-h-[60px] overflow-hidden">
    <div class="flex w-5 bg-blue"></div>
    <div class="flex flex-1 flex-col min-w-[200px] px-4 py-4">
      <div class="text-xl sm:text-2xl font-semibold text-blue-600">{{ title }}</div>
      <div v-if="subtitle" class="text-md font-semibold text-blue-600 leading-none">{{ subtitle }}</div>
      <div v-if="phone && showPhone" class="text-2xl"><a class="text-black" :href="`tel:${phone}`">{{ phone }}</a></div>
      <div v-if="buttonText && buttonLink" class="flex mt-2">
        <SecondaryButton @click="handleClick" :label="buttonText" tone="strong" />
      </div>
      <slot></slot>
    </div>
  </div>
</template>
